import { formatPrice } from './helpers.js'

function escapeHtml(value) {
  if (value == null) return ''
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function buildLocationRows(items, locationId) {
  const rows = items
    .map((item) => {
      const detail = item.details.find((d) => d.location == locationId)
      if (!detail) return null
      return { item, detail }
    })
    .filter(Boolean)
    .sort((a, b) => {
      const nameCmp = a.item.name.localeCompare(b.item.name)
      if (nameCmp !== 0) return nameCmp
      return (a.item.variationName || '').localeCompare(
        b.item.variationName || ''
      )
    })

  if (rows.length === 0) {
    return '<tr><td colspan="5" class="empty">No items</td></tr>'
  }

  return rows
    .map(({ item, detail }) => {
      const itemLabel = item.variationName
        ? `${escapeHtml(item.name)}, ${escapeHtml(item.variationName)}`
        : escapeHtml(item.name)
      const vendorName = detail.vendor ? escapeHtml(detail.vendor.name) : ''
      const price = detail.price
        ? escapeHtml(formatPrice(detail.price, true))
        : ''
      const qtyStart =
        detail.qtyStart != null ? escapeHtml(detail.qtyStart) : ''
      return `
        <tr>
          <td class="check"></td>
          <td>${itemLabel}</td>
          <td>${vendorName}</td>
          <td class="num">${price}</td>
          <td class="num">${qtyStart}</td>
        </tr>
      `
    })
    .join('')
}

function buildHtml(sheet, locations) {
  const displayDate = escapeHtml(sheet.displayDate || '')
  const items = sheet.items || []

  const sections = locations
    .map((location) => {
      const rows = buildLocationRows(items, location.id)
      return `
        <section class="location-section">
          <table>
            <thead>
              <tr class="page-header">
                <th colspan="5" class="page-header-cell">
                  <div class="title">Receiving Log</div>
                  <div class="name">${escapeHtml(location.name)}</div>
                  <div class="sub">${displayDate}</div>
                </th>
              </tr>
              <tr>
                <th class="check">&#10003;</th>
                <th>Item</th>
                <th>Vendor</th>
                <th class="num">Price</th>
                <th class="num">Qty Start</th>
              </tr>
            </thead>
            <tbody>${rows}</tbody>
          </table>
        </section>
      `
    })
    .join('')

  return `<!doctype html>
<html>
<head>
  <meta charset="utf-8" />
  <title>Receiving Log — ${displayDate}</title>
  <style>
    @page { size: letter; margin: 0.5in; }
    * { box-sizing: border-box; }
    body {
      font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif;
      color: #000;
      margin: 0;
    }
    .location-section { page-break-after: always; }
    .location-section:last-child { page-break-after: auto; }
    table { width: 100%; border-collapse: collapse; font-size: 12pt; }
    thead { display: table-header-group; }
    th, td { border: 1px solid #333; padding: 4px 6px; text-align: left; vertical-align: top; }
    th { background: #eee; }
    .num { text-align: right; white-space: nowrap; }
    th.check, td.check { width: 0.4in; text-align: center; }
    td.empty { text-align: center; color: #666; font-style: italic; }
    th.page-header-cell {
      background: #fff;
      border: 0;
      padding: 0 0 0.4rem 0;
    }
    .page-header-cell .title { font-size: 11pt; text-transform: uppercase; letter-spacing: 0.08em; color: #444; font-weight: normal; }
    .page-header-cell .name { font-size: 20pt; font-weight: bold; margin-top: 2px; }
    .page-header-cell .sub { font-size: 11pt; color: #444; margin-top: 2px; font-weight: normal; }
  </style>
</head>
<body>${sections}</body>
</html>`
}

export function printSheet(sheet, locations) {
  const w = window.open('', '_blank')
  if (!w) {
    alert('Please allow pop-ups for this site to print the sheet.')
    return
  }
  const html = buildHtml(sheet, locations)
  w.document.open()
  w.document.write(html)
  w.document.close()
  w.onload = () => {
    w.focus()
    w.print()
  }
}
